import { EnvironmentProviders, importProvidersFrom, makeEnvironmentProviders } from '@angular/core';

import { APOLLO_OPTIONS, ApolloModule } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';

import { ApolloClientOptions, InMemoryCache } from '@apollo/client/core';

import { environment } from '../environments/environment';

function createApollo(httpLink: HttpLink): ApolloClientOptions<unknown> {
  const uri = environment.strapi.graphql_url;

  return {
    link: httpLink.create({ uri }),
    cache: new InMemoryCache({}),
  };
}

export function provideApollo(): EnvironmentProviders {
  return makeEnvironmentProviders([
    importProvidersFrom([ApolloModule]),
    {
      provide: APOLLO_OPTIONS,
      useFactory: createApollo,
      deps: [HttpLink],
    },
  ]);
}
